import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { Card, CardContent } from './ui/Card';
import { Section } from './Section';
import './Contact.css';

export function Contact({ email, phone, social }) {
  return (
    <Section id="contact" title="Get In Touch">
      <div className="contact-content">
        <p className="contact-text">
          Looking to optimize your IT operations and improve your service metrics? Let's talk.
        </p>
        <div className="contact-methods">
          <motion.div
            initial={{ y: 20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.5, delay: 0 }}
            viewport={{ once: true }}
          >
            <Card>
              <CardContent>
                <div className="contact-method-header">Email</div>
                <a href={`mailto:${email}`} className="contact-method-link">
                  {email}
                </a>
              </CardContent>
            </Card>
          </motion.div>
          {phone && (
            <motion.div
              initial={{ y: 20, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              viewport={{ once: true }}
            >
              <Card>
                <CardContent>
                  <div className="contact-method-header">Phone</div>
                  <a href={`tel:${phone}`} className="contact-method-link">
                    {phone}
                  </a>
                </CardContent>
              </Card>
            </motion.div>
          )}
        </div>
        <div className="social-links">
          {social.linkedin && (
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              whileInView={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <Button
                variant="default"
                size="md"
                onClick={() => window.open(social.linkedin, '_blank')}
              >
                Connect on LinkedIn
              </Button>
            </motion.div>
          )}
        </div>
      </div>
    </Section>
  );
}

export function Footer() {
  return (
    <footer className="footer">
      <p>&copy; 2024 Sebastian. All rights reserved.</p>
    </footer>
  );
}
